import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'

export default class SliderItinerancesAction {
    constructor() {
        SliderItinerancesAction.itinerances_slider().then()
    }

    static async itinerances_slider() {
        const galleryThumbs = await Swiper.create('[data-id="slider-thumbs"]', {
            slidesPerView: 4,
            touchRatio: 0,
            allowTouchMove: false,
        })

        if ($('.itinerances__list').length > 0) {
            await Swiper.create('[data-id="slider-itinerances"]', {
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: false,
                speed: 600,
                slidesPerView: 1,
                loop: true,
                lazy: true,
                thumbs: {
                    swiper: galleryThumbs,
                },
            })
        }
    }
}
